import { Box, LinearProgress, Typography, useTheme } from '@mui/material';
import type { Progress as ProgressBarProps } from 'src/lib/flows/flow-definition';

const MIN = 0;
const normalize = (value: number, max: number): number =>
  ((value - MIN) * 100) / (max - MIN);

const ProgressBar: React.FC<ProgressBarProps> = ({
  show,
  value,
  max,
  label,
}) => {
  const theme = useTheme();
  if (!show) {
    return null;
  }
  return (
    <Box
      marginBottom={3}
      sx={{
        [theme.breakpoints.up('sm')]: {
          width: '33.33%',
          marginBottom: 4,
        },
      }}
    >
      <Typography
        component="p"
        variant="textSmall"
        marginBottom={1}
        color="text.secondary"
      >
        Part {value} of {max}: {label}
      </Typography>
      <LinearProgress
        color="primary"
        variant="determinate"
        value={normalize(value, max)}
      />
    </Box>
  );
};
export default ProgressBar;
